import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL || 'https://keycloak.athenasecuritygrp.com',
  realm: process.env.REACT_APP_KEYCLOAK_REALM || 'athena-security',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'pallas-ui',
});

export const keycloakInitOptions = {
  onLoad: 'login-required',
  checkLoginIframe: false,
  pkceMethod: 'S256',
  // Pallas uses the URL fragment for its own module routing (#chat, etc.).
  // Keep the OIDC callback outside that fragment so the SPA cannot overwrite it.
  flow: 'standard',
  responseMode: 'query',
};

export default keycloak;
